import { trpcTenant } from '@duke-hq/app-provider-web/tenant/trpcTenant';
import CourseFilterBase from '../CourseFilterBase';

export default function CourseFilter() {
  const { data } = trpcTenant.courses.all.useQuery(
    { includeSupersededCourses: true, excludeInternalEnrolments: true },
    { initialData: [] },
  );
  return <CourseFilterBase data={data} />;
}
